import { Stack } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, PrimaryPaper } from '@atoms/layout';
import { DataGrid } from '@molecules/dataDisplay';
import { EmptyListPlaceholder } from '@molecules/dataDisplay';
import { ShiftsIcon } from '@atoms/icons';
import { useAgenciesListColumns } from '../columns';
import { useAgenciesListStore } from '@libs/store/agencies/agenciesListStore';
import { useEffect } from 'react';
import { useRefreshSyncStore } from '@libs/store/refreshSync';
import { AgenciesFilters } from './filters';
import { useAgenciesListFiltersStore } from '@libs/store/agencies';

type Props = {
  localizationSubset: string;
};
const DEFAULT_PAGE_SIZE = 10;
export function AgenciesListPage({ localizationSubset }: Props) {
  const intl = useIntl();
  const { page, perPage, total, agencies, loadAgencies, loadingList } = useAgenciesListStore();
  const { refreshTrigger } = useRefreshSyncStore();
  const { activeFilters } = useAgenciesListFiltersStore();

  useEffect(() => {
    loadAgencies(activeFilters, 1, DEFAULT_PAGE_SIZE);
  }, [loadAgencies, refreshTrigger, activeFilters]);

  const loading = loadingList;
  return (
    <Box aria-label="AgenciesListSubpage" sx={{ height: '100%', width: '100%' }}>
      <PrimaryPaper sx={{ height: '100%', minHeight: 0, mt: 2 }}>
        <Stack spacing={2} sx={{ height: '100%', width: '100%' }}>
          <AgenciesFilters loading={loading} localizationSubset={localizationSubset} />
          <DataGrid
            rows={agencies}
            loading={loading}
            rowHeight={64}
            columns={useAgenciesListColumns(localizationSubset)}
            hideFooter
            disableRowSelectionOnClick
            noRowsOverlay={
              <EmptyListPlaceholder
                icon={<ShiftsIcon active />}
                title={<FormattedMessage id={`${localizationSubset}.table.noRows.title`} />}
                subtitle={<FormattedMessage id={`${localizationSubset}.table.noRows.subtitle`} />}
              />
            }
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: DEFAULT_PAGE_SIZE,
                },
              },
            }}
            onPaginationModelChange={(params) => {
              loadAgencies(activeFilters, params.page, params.pageSize);
            }}
            paginationModel={{
              pageSize: perPage,
              page: page,
            }}
            rowCount={total}
            pageSizeOptions={[DEFAULT_PAGE_SIZE, 20]}
          />
        </Stack>
      </PrimaryPaper>
    </Box>
  );
}
